const BASIC = "BASIC";
const PRO = "PRO";
const ENTERPRISE = "ENTERPRISE";
const ESSENTIAL = "ESSENTIAL";
const SPOT = "SPOT";
const SPOT_CON = "SPOT-CON";
const CLASSIC = "CLASSIC";
const SECONDARY = "SECONDARY"

export { BASIC, CLASSIC, ENTERPRISE, ESSENTIAL, PRO, SECONDARY, SPOT, SPOT_CON };

